import { gql } from '@apollo/client';

export const DOWNLOAD_RECORDINGS_BATCH = gql`
  mutation Mutation($recordingIds: [String]!, $metadataOnly: Boolean) {
    downloadRecordingsBatch(recordingIds: $recordingIds, metadataOnly: $metadataOnly) {
      success
      error
    }
  }
`;
